/* eslint-disable react/no-danger */
import { h, Fragment } from 'preact';
import CloseIcon from '../utils/icons/close.svg';

const SpecificationsFlyout = ({
  specificationsData,
  element,
  isOpen,
  setIsOpen,
}) => {
  const modalClass = isOpen ? 'modal panel-active' : 'modal modal--closed';
  const specMetafields = JSON.parse(
    element.querySelector('[data-specifications-data]').textContent,
  );
  const { title, specificationsBlocks } = specMetafields;

  const handleCloseClick = (e) => {
    e.preventDefault();
    setIsOpen(false);
    document.body.style.overflow = '';
  };

  return (
    <>
      {isOpen && (
        <div
          className="bg-bg-3 opacity-70 w-screen  h-screen z-20 inset-1/2 translate-y-[-50%] translate-x-[-50%] fixed"
          onClick={handleCloseClick}
        />
      )}
      <div
        className={`${modalClass} fixed left-full max-w-width w-full bg-white z-30 translate-x-full transition-transform ease-ease delay-300 flex-col flex
            px-5 py-6
            laptop:translate-x-0 laptop:translate-y-full laptop:pb-24 laptop:rounded-t-sm`}
      >
        <div className="flex justify-between py-3.5 px-5 tablet:py-0 tablet:px-0">
          <h5 className="heading-5">{title}</h5>
          <button onClick={handleCloseClick} aria-label="Close the flyout">
            <CloseIcon />
          </button>
        </div>
        <div className="custom-scrollbar flex flex-col justify-between gap-12 pb-3.5 px-5 tablet:py-0 tablet:px-0 tablet:flex-row tablet:mt-11 overflow-y-auto">
          <div className="custom-scrollbar scrollbar-specs w-full flex flex-wrap gap-y-11 pt-3.5 border-t border-t-grey-400 tablet:overflow-y-auto tablet:h-fit tablet:max-h-[31rem] tablet:w-3/5 tablet:pt-12">
            {!!specificationsData.length
              && specificationsData.map((spec, index) => (
                <div
                  className="w-1/2 h-auto tablet:w-1/3 pr-2.5"
                  key={`spec_data-${index}`}
                >
                  <p className="font-m-14 tablet:font-m-12 laptop:font-m-14 text-secondary-1 capitalize">
                    {spec.key.replace('_', ' ')}
                  </p>
                  <p className="subheading-3 text-primary-1">{spec.value}</p>
                </div>
              ))}
          </div>
          <div className="w-full flex flex-col gap-y-5 tablet:h-fit tablet:max-h-full tablet:w-2/5 tablet:overflow-y-auto">
            {specificationsBlocks.map((spec, index) => (
              <div key={index} className="bg-bg-6 rounded-1 pt-8 px-6 pb-3">
                <h5 className="subheading-3 text-primary-1 mb-4">
                  {spec.title}
                </h5>
                <div
                  className="font-r-14 text-primary-1 pb-9 mb-3 border-b border-b-primary-1"
                  dangerouslySetInnerHTML={{ __html: spec.subcopy }}
                />
                <a
                  href={spec.cta_url}
                  class="btn-primary-stroke-arrow bg-transparent border-0 w-full px-0 before:right-0 hover:after:right-0"
                >
                  {spec.cta_text}
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default SpecificationsFlyout;
